<template>
  <div class="linewidth-palette clearfix">
    <div class="palette-button line-palette-item" data-cmd="setLineWidth" data-arg=".5">
      <div class="line-icon line-icon-0"></div>
    </div>
    <div class="palette-button line-palette-item" data-cmd="setLineWidth" data-arg="1">
      <div class="line-icon line-icon-1"></div>
    </div>
    <div class="palette-button line-palette-item" data-cmd="setLineWidth" data-arg="3">
      <div class="line-icon line-icon-3"></div>
    </div>
    <div class="palette-button line-palette-item" data-cmd="setLineWidth" data-arg="5">
      <div class="line-icon line-icon-5"></div>
    </div>
    <div class="palette-button line-palette-item" data-cmd="setLineWidth" data-arg="7">
      <div class="line-icon line-icon-7"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

  $w: 40px;

  .linewidth-palette {
    width: $w * 1;
  }

  .line-palette-item {
    width: 40px;
    height: 40px;

    &:hover {
      div {
        background-color: #fff;
        &.line-icon-0 {
          height: 1px;
          background: none;
          border-top: 1px dotted #fff;
        }
      }
    }
  }
</style>

<script>
  import state from '../../data/state';

  export default{
    data(){
      return {
        state
      }
    },

  }
</script>



// WEBPACK FOOTER //
// LineWidths.vue?980c2a94